import script from "./QuestionnairePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionnairePage.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionnairePage.vue?vue&type=style&index=0&id=6ee68960&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee68960"]])

export default __exports__